export class Audience{
  ClientId: string;
  Name: string;
  Base64Secret: string;
}



// WEBPACK FOOTER //
// ./src/app/model/audience.ts